import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-header-with-icon',
  templateUrl: './header-with-icon.component.html',
  styleUrls: ['./header-with-icon.component.scss']
})
export class HeaderWithIconComponent implements OnInit {
  @Input() iconClass;
  @Input() title;

  private params: any;
  iconParams: BehaviorSubject<{iconClass: string, title: string}> =
    new BehaviorSubject<{iconClass: string, title: string}>({iconClass: '', title: ''});
  constructor() { }

  ngOnInit() {
    if (this.iconClass) {
      this.iconParams.next({iconClass: this.iconClass, title: this.title});
    }
  }
  // when used as ag-grid cell
  agInit(params: any): void {
    this.iconParams.next(params.iconParams);
    this.params = params;
  }
  onSortRequested(event) {
    if (this.params.column.isSortAscending()) {
      this.params.setSort('desc', event.shiftKey);
    } else if (this.params.column.isSortDescending()) {
      this.params.setSort(null, event.shiftKey);
    } else {
      this.params.setSort('asc', event.shiftKey);
    }
  }
}
